module.exports = __webpack_public_path__ + "img/profile-man-9-min.39e66883.jpg";